// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b21a91d2","551":"5758ca26","683":"46e8c224"}[chunkId] + ".chunk.js";
};